var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"inlineError",class:[
    _vm.snackbar.type,
    {
      'inline-error': true,
      'inline-error--visible': _vm.snackbar.show,
      'inline-error--hide': !_vm.snackbar.show,
    }
  ],style:(_vm.snackbarStyles)},[_c('div',{staticClass:"inline-error__message muted-immutable--text"},[_vm._v(" "+_vm._s(_vm.snackbar.text)+" ")]),(_vm.showCloseBtn && _vm.snackbar.show)?_c('v-icon',{staticClass:"inline-error__close",attrs:{"color":"muted-immutable"},on:{"click":_vm.close}},[_vm._v(" close ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }